import * as React from 'react';

var _path, _path2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.759 7.355h6.414l.003 6.304h3.667l.5.5v8.886l-.5.5h-2.78v-1h2.28v-7.886h-3.166v.003H13.02v-.003H9.85v7.886h2.369v1h-2.87l-.5-.5v-8.886l.5-.5h3.672v-3.566l2.738-2.738zm5.414 1l.003 5.304h-7.155v-3.152l2.152-2.152h5zm-.92 13.543h-5.305v-1h5.305v1zm-5.305 2.507h3.904v-1h-3.904v1zM11.47 15.08a1.04 1.04 0 00-1.36.566 1.042 1.042 0 101.984.604 1.042 1.042 0 100-.413 1.04 1.04 0 00-.624-.757zm10.706 3.568h-9.153v8.007h9.153v-8.007zm-8.153 7.007v-6.007h7.153v6.007h-7.153z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.408 2.677a15.5 15.5 0 10-11.85 28.645 15.5 15.5 0 0011.85-28.645zM17.473.5a16.5 16.5 0 11.02 33 16.5 16.5 0 01-.02-33z"
  })));
}

export { SvgPrint as default };